module.exports = __webpack_public_path__ + "static/media/img-placeholder.a9e24e1b.png";